import { useEffect, useRef, useState } from 'react';

const useIsTruncated = <T extends HTMLElement = HTMLElement>(
  dependency?: unknown
) => {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    const measure = () =>
      setIsTruncated(
        element.scrollWidth > element.clientWidth ||
          element.scrollHeight > element.clientHeight
      );

    measure();

    // Re-measure when the element's box changes
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [dependency]);

  return { ref, isTruncated };
};

export default useIsTruncated;
